/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlExecRiskStats
 */
export interface ControlExecRiskStats {
    /**
     * 
     * @type {number}
     * @memberof ControlExecRiskStats
     */
    liens: number;
    /**
     * 
     * @type {number}
     * @memberof ControlExecRiskStats
     */
    ppploans: number;
    /**
     * 
     * @type {number}
     * @memberof ControlExecRiskStats
     */
    investors: number;
    /**
     * 
     * @type {number}
     * @memberof ControlExecRiskStats
     */
    regulatory_issues: number;
}

/**
 * Check if a given object implements the ControlExecRiskStats interface.
 */
export function instanceOfControlExecRiskStats(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "liens" in value;
    isInstance = isInstance && "ppploans" in value;
    isInstance = isInstance && "investors" in value;
    isInstance = isInstance && "regulatory_issues" in value;

    return isInstance;
}

export function ControlExecRiskStatsFromJSON(json: any): ControlExecRiskStats {
    return ControlExecRiskStatsFromJSONTyped(json, false);
}

export function ControlExecRiskStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlExecRiskStats {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'liens': json['liens'],
        'ppploans': json['ppploans'],
        'investors': json['investors'],
        'regulatory_issues': json['regulatory_issues'],
    };
}

export function ControlExecRiskStatsToJSON(value?: ControlExecRiskStats | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'liens': value.liens,
        'ppploans': value.ppploans,
        'investors': value.investors,
        'regulatory_issues': value.regulatory_issues,
    };
}

